import { Pagination } from "services/search";

import { VehicleType, VehicleTypeRow } from "./types";

import { DataWithPagination } from "services/api/types";
import { transformVehicleType, transformVehicleTypeRow } from "./transformations";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";

/*---------------------------------------------------------------------------------------
  SEARCH
-----------------------------------------------------------------------------------------*/
export const getVehicleTypesAPI = async (
  vehicleManufacturerId: string,
  vehicleModelId: string,
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<VehicleTypeRow>> => {
  let path = `/v1/catalog/vehicles/manufacturers/${vehicleManufacturerId}/models/${vehicleModelId}/types?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformVehicleTypeRow);
};



/*---------------------------------------------------------------------------------------
    INFO
  -----------------------------------------------------------------------------------------*/

export const getVehicleTypeAPI = async (
  vehicleManufacturerId: string,
  vehicleModelId: string,
  vehicleTypeId: string,
): Promise<VehicleType> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/manufacturers/${vehicleManufacturerId}/models/${vehicleModelId}/types/${vehicleTypeId}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicleType(response.data);
};
